import { useState } from "react";
import { MapPin, Users, CalendarClock } from "lucide-react";
import { SalesKpis } from "./SalesKpis";
import { DealerSalesCallouts } from "./DealerSalesCallouts";
import { SalesTrendChart } from "./SalesTrendChart";
import { StoreLeaderboard } from "./StoreLeaderboard";
import { GroupBreakdown } from "./GroupBreakdown";
import { StoreDetailSheet } from "./StoreDetailSheet";
import { MonthlyHistoryChart } from "./MonthlyHistoryChart";
import { StoreRankings } from "./StoreRankings";
import { SalesDealerReport } from "./SalesDealerReport";
import { monthLabel } from "./SalesPeriodBar";

export const LastSyncBadge = ({ lastSync }) => (
  <div className="flex items-center gap-2 text-xs text-slate-600" data-testid="vz-last-sync">
    <CalendarClock className="w-4 h-4 text-teal" />
    {lastSync ? (
      <span>Data through <b>{lastSync.updated_through || "—"}</b> · synced {new Date(lastSync.synced_at).toLocaleString()}</span>
    ) : <span>No Verizon data synced yet</span>}
  </div>
);

export const VerizonSalesView = ({ summary, mode, onChanged }) => {
  const [selected, setSelected] = useState(null);
  const isAdmin = mode === "admin";
  return (
    <div className="space-y-6" data-testid="vz-sales-view">
      {isAdmin ? <SalesKpis totals={summary.totals} period={summary.period} compare={summary.compare} /> : <DealerSalesCallouts summary={summary} />}
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2"><SalesTrendChart trend={summary.trend} /></div>
        <GroupBreakdown title="By Market" icon={MapPin} groups={summary.by_market} testId="vz-by-market" />
      </div>
      <StoreLeaderboard stores={summary.stores} columns={summary.leaderboard_columns} onSelect={setSelected} showStoreInfo={isAdmin} />
      {!isAdmin && <StoreRankings stores={summary.stores} columns={summary.leaderboard_columns} overallTotal={summary.overall_total} />}
      <MonthlyHistoryChart monthly={summary.monthly} />
      <SalesDealerReport admin={isAdmin} month={isAdmin ? undefined : summary.period?.end} monthText={isAdmin ? undefined : monthLabel(summary.period?.end)} />
      {isAdmin && <GroupBreakdown title="By Sub-Agent (Dealer)" icon={Users} groups={summary.by_sub_agent} testId="vz-by-subagent" />}
      <StoreDetailSheet store={selected} mode={mode} onClose={() => setSelected(null)} />
    </div>
  );
};
